import React, { memo } from 'react';
import { StringDetail } from 'requests/RequestPayment';
import classes from './bulk-payment-remarks.module.scss';

type Props = {
	title?: string;
	remarks?: StringDetail[];
};
export const BulkPaymentRemarks = memo((props: Props) => {
	const { title = 'ご確認事項', remarks } = props;

	if (!remarks || remarks.length === 0) {
		return null;
	}

	return (
		<div className={classes.remarksWrap}>
			<div className={classes.remarksTitle}>{title}</div>
			{remarks.map((r) => {
				return (
					<div className={classes.remarksDetailWrap}>
						<div className={classes.remarksDetailTitle}>{r.key}</div>
						<div className={classes.remarksDetail}>{r.value}</div>
					</div>
				);
			})}
		</div>
	);
});
